import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';

import AlertDialog from 'components/AlertDialog';

const mobileLink = locale =>
  ({
    fi: 'https://my.stellarq.fi/fi/ms',
    sv: 'https://my.stellarq.fi/se/ms',
    en: 'https://my.stellarq.fi/en/ms'
  }[locale]);

const LoginInfoDialog = ({ dialogOpen, closeDialog, intl }) => {
  const url = mobileLink(intl.locale);
  const Link = () => (
    <a href={url} target="_blank">
      {url}
    </a>
  );

  return (
    <AlertDialog
      visible={dialogOpen}
      alertMessage={
        <div>
          <FormattedMessage id="dictionary.mobileInfoText" />
          &nbsp;
          <Link />
          <span>. </span>
          <FormattedMessage id="dictionary.mobileInfoText2" />
        </div>
      }
      cancelButtonText="dictionary.close"
      onCancel={() => closeDialog()}
      formatMessage={props => <FormattedMessage {...props} />}
      cancelButtonStyle={{ button: 'raised', primary: true }}
      dontFormatMessage
    />
  );
};

LoginInfoDialog.propTypes = {
  dialogOpen: PropTypes.bool,
  setDialogOpen: PropTypes.func,
  intl: intlShape
};

export default injectIntl(LoginInfoDialog);
